import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../../store/actions";
import { useLocation } from 'react-router-dom';

import "../datatables.scss"
import { PAGECODE, PAGEPATHS } from "components/Common/Constant/index";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { showToaster } from "components/Common/common";

const DatatableTables = (props) => {
  const location = useLocation();
  const { user: details } = location.state || {};
  const [isUpdated, setIsUpdated] = useState(false)

  document.title = "Access Management";
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "User Management", link: PAGEPATHS.Usermanage },
    { title: "Access Management", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems('Access Management', breadcrumbItems)
  })

  const handlePermission = (perm, page, e) => {
    const value = PAGECODE[page];
    const isChecked = e.target.checked;

    let newRead = [...details.permissions.read];
    let newWrite = [...details.permissions.write];

    if (perm === false) {
      if (isChecked) {
        newRead = newRead.filter(p => p !== value);
        newWrite = newWrite.filter(p => p !== value);
      }
    } else if (perm === 'read') {
      if (isChecked) {
        if (!newRead.includes(value)) newRead.push(value);
      } else {
        newRead = newRead.filter(p => p !== value);
        newWrite = newWrite.filter(p => p !== value);
      }
    } else if (perm === 'write') {
      if (isChecked) {
        if (!newWrite.includes(value)) newWrite.push(value);
        if (!newRead.includes(value)) newRead.push(value);
      } else {
        newWrite = newWrite.filter(p => p !== value);
      }
    }

    details.permissions.read = newRead;
    details.permissions.write = newWrite;
    updateUserDetail();
    setIsUpdated(true);
  };

  const updateUserDetail = () => {
    const format = Object.keys(PAGECODE).reduce((a, k) => {
      const data = {
        pagename: k,
        readonly: (<div className="text-center"> <input onClick={(e) => handlePermission('read', k, e)} checked={details.permissions.read.includes(PAGECODE[k])} type="checkbox" /> </div>),
        writeonly: (<div className="text-center"> <input onClick={(e) => handlePermission('write', k, e)} checked={details.permissions.write.includes(PAGECODE[k])} type="checkbox" /> </div>),
        notavailable: (<div className="text-center"> <input onClick={(e) => handlePermission(false, k, e)} checked={!details.permissions.read.includes(PAGECODE[k]) && !details.permissions.write.includes(PAGECODE[k])} type="checkbox" /> </div>),
      }
      a.push(data)
      return a
    }, [])

    setData((pre) => ({
      ...pre,
      columns: pre.columns,
      rows: format
    }))
  }

  useEffect(() => {
    if (!details) {
      navigate(PAGEPATHS.Usermanage)
      return
    }
    updateUserDetail()
  }, [])

  const updateUserData = async () => {
    try {
      const payload = { permissions: details.permissions,
          firstname: details.firstname,
          lastname: details.lastname,
       }
      const { data } = await axiosInstance
        .put(`${ApiNames.USER_UPDATE}/${details._id}`,
          payload,
          {
            headers: {
              "if-match": details.__v
            }
          }
        )

      if (data.status === 1) {
        showToaster(data.status, "Permissions updated");
        navigate(PAGEPATHS.Usermanage)
      }
    } catch (e) {
      console.error(e);

    }
  }

  const [data, setData] = useState({
    columns: [
      {
        label: "Page Name",
        field: "pagename",
        sort: "asc",
        width: 150,
      },
      {
        label: "Read Only",
        field: "readonly",
        sort: "asc",
        width: 270,
      },
      {
        label: "Write Only",
        field: "writeonly",
        sort: "asc",
        width: 200,
      },
      {
        label: "Not Available",
        field: "notavailable",
        sort: "asc",
        width: 100,
      }
    ],
    rows: []
  })

  return (
    <React.Fragment>

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row>
                <div className="col-8">
                  <CardTitle className="h4">{`${details?.firstname}'s Access Management`}</CardTitle>
                  <p className="card-title-desc">
                    Manage your users and their authority over reports here.
                  </p>
                </div>
                <div className="col-4">
                  {isUpdated &&
                    <button
                      type="button"
                      className="waves-effect float-end d-flex align-items-center waves-light btn btn-orange"
                      style={{ fontSize: "0.9rem" }}
                      onClick={updateUserData}>
                      <i className="mdi mdi-content-save fw-bold font-size-17 pe-1"></i>{" "}
                      Save Changes
                    </button>
                  }
                </div>
              </Row>

              <MDBDataTable entries={50} paging={false} responsive striped data={data} />
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables);
